/* @flow */
import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { Translate, I18n } from 'react-redux-i18n'
import _ from 'lodash'

import './style.css'
import Radio from '../../components/Radio'
import CompoundInput from '../../components/CompoundInput'
import ListItem from '../../components/ListItem'
import { search } from '../../actions/global'
import Preview from '../../components/Preview';

type SearchProps = {}
class Search extends React.Component<SearchProps> {
  constructor(props) {
    super(props)
    this.handleRadioOnChange = this.handleRadioOnChange.bind(this)
    this.state = {
      sortBy: 'rating'
    }
  }

  handleRadioOnChange(value) {
    this.setState({
      sortBy: value
    })
  }

  render() {
    const { scenes, locale, shops, activities, navigate, currency } = this.props
    const { sortBy } = this.state

    const sceneName = scenes[0] && scenes[0].name[locale]
    const sortedActivities = _.orderBy(
      _.map(activities, (activity, key) => ({
        ...activity,
        id: activity.id || key,
      })),
      (item) => {
        if (sortBy === 'lastFor' && item.lastForUnit === 'day') {
          return item[sortBy] * 24
        }
        return item[sortBy]
      },
      ['desc']
    )
    
    return (
      <div className="search-container">
        <div className="inputs">
          <CompoundInput
            dataList={this.props.locations}
            displayFields={"name." + locale}
            placeholder={sceneName || I18n.t('searchPlaceholder')}
            submit={(location, startDate, endDate, experience) => {
              this.props.search(location, startDate, endDate, experience)
              this.props.navigate('/search')
            }} />
        </div>
        {/* <Header title="filter" /> */}
        <div className="functions">
          {/* <div className="filters">
            <Card
              header={<Translate value="divingServices" className="headline headline-light" />}>
              <ul>
                <li><label>
                  <Checkbox className="caerulus" checked />
                  <Translate value="experincingDiving" />
                </label></li>
                <li><label>
                  <Checkbox className="caerulus" checked />
                  <Translate value="licenseDiving" />
                </label></li>
                <li><label>
                  <Checkbox className="caerulus" checked />
                  <Translate value="coastDiving" />
                </label></li>
                <li><label>
                  <Checkbox className="caerulus" checked />
                  <Translate value="boatDiving" />
                </label></li>
                <li><label>
                  <Checkbox className="caerulus" checked />
                  <Translate value="highOxygenDiving" />
                </label></li>
              </ul>
            </Card>

            <Card
              header={<Translate value="otherServices" className="headline headline-light" />}>
              <ul>
                <li><label>
                  <Checkbox className="caerulus" checked />
                  <Translate value="resident" />
                </label></li>
                <li><label>
                  <Checkbox className="caerulus" checked />
                  <Translate value="shuttle" />
                </label></li>
                <li><label>
                  <Checkbox className="caerulus" checked />
                  <Translate value="languageSupport" />
                </label></li>
                <li><label>
                  <Checkbox className="caerulus" checked />
                  <Translate value="freeWifi" />
                </label></li>
                <li><label>
                  <Checkbox className="caerulus" checked />
                  <Translate value="hotShower" />
                </label></li>
              </ul>
            </Card>
          </div> */}
          <div className="options">
            <Translate value="sortType" className="headline headline-light" />
            <div className="option">
              <Radio className="caerulus"
                name="sort"
                value="hot"
                onChange={() => this.handleRadioOnChange('hot')}
                selected={sortBy}
              />
              <Translate value="hotLevel" className="headline" />
            </div>
            <div className="option">
              <Radio className="caerulus"
                name="sort"
                value='rating'
                onChange={() => this.handleRadioOnChange('rating')}
                selected={sortBy}
              />
              <Translate value="customerRecommendation" className="headline" />
            </div>
            <div className="option">            
              <Radio className="caerulus"
                name="sort"
                value="price"
                onChange={() => this.handleRadioOnChange('price')}
                selected={sortBy}
              />
              <Translate value="price" className="headline" />
            </div>
            <div className="option">
              <Radio className="caerulus"
                name="sort"
                value="lastFor"
                onChange={() => this.handleRadioOnChange('lastFor')}
                selected={sortBy}
              />
              <Translate value="lastFor" className="headline" />
            </div>
          </div>
        </div>
        <div className="content">

          <div className="list">
            { sortedActivities.length ?
              _.map(sortedActivities, (activity) => {
                const comments = _.values(activity.comments)
                return <ListItem key={activity.id}>
                  <Preview
                    imageOnLeft
                    locale={locale}
                    subtitle={ shops.length ? _.filter(shops, ['id', activity.shopId])[0].name[locale] : '' }
                    data={activity}
                    onClick={(e) => {
                      navigate('/activity/' + activity.id)
                      e.preventDefault()
                      e.stopPropagation()
                    }}
                    options={[{
                      title: 'lastFor',
                      value: activity.lastFor && (activity.lastFor + I18n.t(activity.lastForUnit))
                    }, {
                      title: 'charge',
                      value: currency.label.toUpperCase() + ' ' + Math.ceil((activity.packages ? activity.packages[0].price : activity.price) * currency.ratio * 100) / 100
                    }, {
                      title: 'assemblyPlace',
                      value: activity.assemblyPlace[locale]
                    }]}
                    footer={[{
                      isRating: true,
                      value: activity.rating
                    }, {
                      title: (comments ? comments.length : 0) + I18n.t('comments'),
                    }, {
                      isButton: true,
                      title: I18n.t('seeDetail'),
                      onClick: (e) => {
                        navigate('/activity/' + activity.id)
                        e.preventDefault()
                        e.stopPropagation()
                      }
                    }]}
                    onHeaderClick={(e) => {
                      navigate('/shop/' + activity.shopId)
                      e.preventDefault()
                      e.stopPropagation()
                    }}
                  />
                </ListItem>}
              ) :
              <ListItem>
                <div className="no-result"><Translate value="noSuitableResult" /></div>
              </ListItem>
            }
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  locale: state.i18n.locale,
  locations: state.scene.locations,
  shops: state.shop.filtered,
  scenes: state.scene.filtered,
  activities: state.activity.filtered,
  currency: state.global.currency,
})

const mapDispatchToProps = (dispatch) => ({
  navigate: (location) => dispatch(push(location)),
  search: (location, startDate, endDate, experience) =>
    dispatch(search(location, startDate, endDate, experience)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Search)


// WEBPACK FOOTER //
// ./src/containers/Search/index.js